<div class="view-internal-header">
  <!-- Header -->
  <div class="view-internal-header__controls">
    <a class="view-internal-header__logo" routerLink="/" matTooltip="Back to Dashboard"></a>

    <div class="panel__actions hide-sm">
      <button app-button buttonTheme="light" [routerLink]="['/edit']" [queryParams]="{'id': id}">
        <app-button-icon icon="pen" label="Edit in Studio" iconPlacement="left"></app-button-icon>
      </button>

      <app-bookmark-actions
        theme="light" 
        [bookmarkId]="id"
        [bookmarkType]="type"
        [bookmarkActions]="bookmarkActions">
      </app-bookmark-actions>
    </div>
  </div>

  <a class="view-internal-header__breadcrumb" *ngIf="type === 'module' && category" [routerLink]="['/explore', category]">
    <app-icon icon="caret-left"></app-icon> {{ category | humanize }}
  </a>
</div>